import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';

import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import CircularProgress from '@material-ui/core/CircularProgress';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';

import ReportFilters from './ReportFilters';
import ReportToolbar from './ReportToolbar';


const useStyles = makeStyles(theme => ({
    paper: {
        flexGrow: 1,
        backgroundColor: theme.palette.background.paper,
        padding: theme.spacing(3),
    },
    tableHeader: {
        backgroundColor: theme.palette.primary.main,
        '& .MuiTableCell-head': {
            color: theme.palette.primary.contrastText,
        },
    }
}));

const PackagesReport = () => {
    const classes = useStyles();
    const reportUrl = '/api/reports/packages';
    const reportTitle = 'Packages Report';
    const pageTitle = `${reportTitle} - Enduring Promises`;
    const [data, setData] = React.useState(null);
    const [loading, setLoading] = React.useState(true);

    const [state, setState] = React.useState({
        year: new Date().getFullYear(),
        status: 'Complete',
    });

    const getData = state => {
        new Promise((resolve, reject) => {
            fetch(`${reportUrl}?year=${state.year}&status=${state.status}`)
                .then(response => {
                    return response.json();
                })
                .then(result => {
                    setData(result);
                    resolve();
                })
                .finally(() => {
                    setLoading(false);
                });
        });
    };

    useEffect(() => {
        document.title = pageTitle;
        getData(state);
    }, [1]);

    const handleSubmit = () => {
        getData(state);
    };

    const csvData = (data) => {
        const rows = [];
        Object.values(data.data).forEach(row => {
            rows.push([
                row.title,
                row.count
            ]);
        });
        return {
            filename: 'packages-report.csv',
            columns: ["Package", "Total"],
            rows,
        }
    }

    return (
        <Paper square className={classes.paper}>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Typography variant="h6">{reportTitle}</Typography>
                </Grid>
                <Grid item xs={8}>
                    <ReportFilters state={state} setState={setState} handleSubmit={handleSubmit} />
                </Grid>
                <Grid item xs={4}>
                    <Grid
                        container
                        direction="row"
                        justify="flex-end"
                        alignItems="center"
                    >
                        {data !== null && data.data !== null && <ReportToolbar data={csvData(data)} />}
                    </Grid>
                </Grid>
                <Grid item xs={12}>
                    <TableContainer component={Paper} variant="outlined" square style={{width: 425, maxWidth: '100%'}}>
                        <Table size="small">
                            <TableHead className={classes.tableHeader}>
                                <TableRow>
                                    <TableCell align="left">Package</TableCell>
                                    <TableCell align="center">Total</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                            {!loading && data !== null && data.data !== null && Object.values(data.data).map((row, i) => {
                                return (
                                    <TableRow key={`row-${i}`}>
                                        <TableCell align="left">{row.title}</TableCell>
                                        <TableCell align="center">{row.count}</TableCell>
                                    </TableRow>
                                )
                            })}
                            {!loading && data !== null && data.data.length === 0 && (
                                <TableRow>
                                    <TableCell colSpan={4} align="center">No data</TableCell>
                                </TableRow>
                            )}
                            {loading && (
                                <TableRow>
                                    <TableCell colSpan={4} align="center">
                                        <CircularProgress color="primary" />
                                    </TableCell>
                                </TableRow>
                            )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                    {!loading && data !== null && data.data !== null && <p className="mt-3 mb-0">Total: {data.total}</p>}
                </Grid>
            </Grid>
        </Paper>
    );
}

export default PackagesReport;
